import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
// import { EmpresaService } from './services/empresa.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
  standalone: true,
})
export class AppComponent {
  title = 'dashboard-ic';

  // constructor(private empresaService: EmpresaService) {
  //   // // TODO: Mover asignación de código al login
  //   // empresaService.setIdEmpresa(3);
  // }
}
